@import "~@govbr-ds/core/src/components/checkbox/checkbox";

:host {
  display: block;
}
